import axios from "axios";

axios.defaults.baseURL = "https://www.googleapis.com";
axios.defaults.headers.common["Content-Type"] = "application/json";

const client = axios.create();
let requestInterceptorIndex = -1;

export const init = ({ token, ...restParams }) => {
    // Request interceptor for API calls
    if (requestInterceptorIndex >= 0) {
        client.interceptors.request.eject(requestInterceptorIndex);
    }
    requestInterceptorIndex = client.interceptors.request.use(async (config) => {
        config.headers = {
            Authorization: token,
        };
        return config;
    }, Promise.reject);
};

// // Response interceptor for API calls
// client.interceptors.response.use(
//     (response) => response,
//     async function (error) {
//         const originalRequest = error.config;
//         if (error.response.status === 403 && !originalRequest._retry) {
//             if (canRefreshToken(originalRequest.url)) {
//                 originalRequest._retry = true;
//                 const rt = getRefreshToken();
//                 if (rt) {
//                     axios.defaults.headers.common["Authorization"] = await doRefreshToken(rt, post);
//                     return client(originalRequest);
//                 }
//                 return processTokenError(error);
//             }
//             return processTokenError(error);
//         }
//         return Promise.reject(error);
//     }
// );

export async function get({ url, data }) {
    const response = await client.get(url, { params: data });
    return response;
}

export async function post({ url, data, config }) {
    const response = await client.post(url, data, config);
    return response;
}

export async function put({ url, data }) {
    const response = await client.put(url, data);
    return response;
}

export async function deleteAll({ url, data }) {
    const response = await client.delete(url, { data });
    return response;
}

export async function patch({ url, data }) {
    const response = await client.patch(url, data);
    return response;
}
